module.exports = __webpack_public_path__ + "img/CS-Profi13_Overview-Front_1.5a6541d8.jpg";